import React from 'react';
import S from './BasicTextarea.module.css';

const BasicTextarea = ({ id, placeholder, name, onChange, className }) => {
  return (
    <textarea 
      id={id}
      placeholder={placeholder}
      onChange={onChange}
      name={name}
      className={S[className]}
    />
  );
};

export default BasicTextarea;